import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import type { State } from 'state';
import { fetchVisitPortalModel } from 'state/actions/invited-sign-up';
import { getContactLink } from 'state/selectors/env';
import { getSharedPortalName } from 'state/selectors/help-center';
import { getFormSubmitState } from 'state/selectors/invited-sign-up';
import { getIsFailedLoginAttempt } from 'state/selectors/login';
import { isLoggedIn } from 'state/selectors/user';
import { getInitialError, isLoggedInBeforeCheck, getEmail } from 'state/selectors/visit-portal';
import { withPathParams } from '@atlassian/help-center-common-component/with-path-params';

import InvitedSignUpComponent from './invited-sign-up';

const selector = createSelector(
    (state: State) => getInitialError(state),
    (state: State) => getIsFailedLoginAttempt(state),
    (state: State) => isLoggedIn(state),
    (state: State) => isLoggedInBeforeCheck(state),
    (state: State) => getEmail(state),
    (state: State) => getContactLink(state),
    (state: State) => getFormSubmitState(state),
    (state: State) => getSharedPortalName(state),
    (
        initialError,
        isFailedLoginAttempt,
        userLoggedIn,
        loggedInBeforeCheck,
        email,
        contactLink,
        formSubmitState,
        helpCenterName
    ) => ({
        loggedInBeforeCheck,
        email,
        isFailedLoginAttempt,
        contactLink,
        formSubmitState,
        helpCenterName,
        error: initialError && initialError.error,
        isLoading: email === undefined || email === '',
        isLoggedIn: userLoggedIn,
    })
);

export default withPathParams(
    connect(selector, {
        fetchVisitPortalModelAction: fetchVisitPortalModel,
    })(InvitedSignUpComponent)
);
